module.exports = __webpack_public_path__ + "img/btn-fly-2.9cb61fe2.png";